class ScreenRe{
    constructor(disabled){
        this.stream= null,
        // 媒体录制
        this.mediaRecorder= null,
        // 数据块
        this.chunks= [],
        // 录制结果
        this.recording= null,
        // 按钮禁用
        this.disabled= disabled
    }
    // 获取屏幕分享的权限
    openScreenCapture() {
        if (navigator.getDisplayMedia) {
          return navigator.getDisplayMedia({ video: true });
        } else if (navigator.mediaDevices.getDisplayMedia) {
          return navigator.mediaDevices.getDisplayMedia({ video: true });
        } else {
          return navigator.mediaDevices.getUserMedia({
            video: { mediaSource: "screen" }
          });
        }
      }
      // 开始屏幕分享录制
      async start() {
          console.log('录制');
        this.disabled.start = true;
        this.disabled.stop = false;
        this.disabled.download = true;
  
        if (this.recording) {
          window.URL.revokeObjectURL(this.recording);
        }
  
        // 获取屏幕分享权限
        this.stream = await this.openScreenCapture();
        // 实例化一个MediaRecorder对象
        this.mediaRecorder = new MediaRecorder(this.stream, {
          mimeType: "video/webm;codecs=vp8"
        });
        // 监听可用数据
        this.mediaRecorder.addEventListener("dataavailable", event => {
          if (event.data && event.data.size > 0) {
            this.chunks.push(event.data);
          }
        });
        // 开始录制
        this.mediaRecorder.start(10);
      }
      // 停止屏幕分享录制
      stop() {
        console.log('结束');
        this.disabled.start = true;
        this.disabled.stop = true;
        this.disabled.download = false;
  
        // 停止录制
        this.mediaRecorder.stop();
        // 释放MediaRecorder
        this.mediaRecorder = null;
        // 停止所有流式视频轨道
        this.stream.getTracks().forEach(track => track.stop());
        // 释放getDisplayMedia或getUserMedia
        this.stream = null;
  
        // 获取当前文件的一个内存URL
        this.recording = window.URL.createObjectURL(
          new Blob(this.chunks, { type: "video/webm" })
        );
        this.download()
      }
      // 下载录制的视频内容
      download() {
          console.log(this.recording);
          this.disabled.start = false;
          this.disabled.stop = true;
          this.disabled.download = true;

          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = this.recording;
          link.setAttribute('download', 'load.webm')
          
          document.body.appendChild(link)
          link.click()
      }
}
export default ScreenRe